import { combineEpics, ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, startWith } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import { AppState } from '@reducers/rootReducer';
import { ReduxAction } from '../types';
import { apiObservable } from '@support/api';

/* Epic actions */
const reconnectNumberPerDayEpic = requestActions('RECONNECT_NUMBER_PER_DAY', ['fetch', 'update']);

/* Component actions */
export const fetchReconnectNumberPerDay = reconnectNumberPerDayEpic['fetch'];
export const updateReconnectNumberPerDay = reconnectNumberPerDayEpic['update'];

/* Selectors */
export const reconnectNumberPerDaySelector = (state: AppState) =>
  state.data.userSettings.reconnectNumberPerDay;

/* Epics */
export const fetchReconnectNumberPerDayEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('FETCH_RECONNECT_NUMBER_PER_DAY'),
    mergeMap(() =>
      apiObservable('GET', '/users/reconnect-settings/').pipe(
        map(reconnectNumberPerDayEpic['fetchSucceeded']),
        startWith(reconnectNumberPerDayEpic['fetchRequested']()),
        catchError((err) => of(reconnectNumberPerDayEpic['fetchFailed'](err))),
      ),
    ),
  );

export const updateReconnectNumberPerDayEpic = (action$: Observable<ReduxAction>) =>
  action$.pipe(
    ofType('UPDATE_RECONNECT_NUMBER_PER_DAY'),
    mergeMap(({ payload }) =>
      apiObservable('PATCH', '/users/reconnect-settings/', {
        number_per_day: payload.numberPerDay,
      }).pipe(
        map(reconnectNumberPerDayEpic['updateSucceeded']),
        startWith(reconnectNumberPerDayEpic['updateRequested']()),
        catchError((err) => of(reconnectNumberPerDayEpic['updateFailed'](err))),
      ),
    ),
  );

export const userSettingsEpic = combineEpics(
  fetchReconnectNumberPerDayEpic,
  updateReconnectNumberPerDayEpic,
);
